<template>
  <main
    role="main"
    class="col content-spacing"
    style="max-width: 90% !important;"
  >
    <div
      class="d-flex justify-content-between align-items-start pt-3 pb-2 mb-3 border-bottom"
    >
      <div class="d-inline-flex">
        <h1 class="h2">Investimentos</h1>

        <hr class="vertical-bar" />
      </div>

      <b-form-input
        autofocus
        v-on:keyup.enter="search"
        v-model="viewData.search"
        placeholder="Digite um termo e pressione enter para buscar"
        class="mr-3"
      ></b-form-input>

      <BaseButtonComponent to="/investment/new" variant="primary-action"
        >Novo</BaseButtonComponent
      >
    </div>

    <loading-list v-if="viewData.loading"></loading-list>
    <div
      class="d-flex justify-content-between flex-column h-100"
      v-else-if="!viewData.loading"
    >
      <v-table :fixedColumns="false">
        <thead>
          <tr>
            <td>Nome</td>
            <td @click="sortList('depositDate')" style="cursor: pointer;">
              Data do deposito
              <b-icon
                v-if="!this.fields.depositDate"
                icon="arrow-up-short"
                scale="1.5"
                variant="dark"
              ></b-icon>
              <b-icon
                v-if="isTopDirection && this.fields.depositDate"
                icon="arrow-up-short"
                scale="1.5"
                variant="success"
              ></b-icon>
              <b-icon
                v-if="!isTopDirection && this.fields.depositDate"
                icon="arrow-down-short"
                scale="1.5"
                variant="success"
              ></b-icon>
            </td>
            <td>Valor</td>
            <td>Status</td>
            <td></td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in state.list" :key="item.id">
            <td>{{ item.name }}</td>
            <td>{{ item.depositDate }}</td>
            <td>{{ item.value }}</td>
            <td>{{ item.status === 'ACTIVE' ? 'Ativo' : 'Inativo' }}</td>
            <td style="text-align: right">
              <BaseButtonComponent
                :to="`/investment/edit/${item.id}`"
                size="sm"
                v-b-tooltip.hover
                title="Editar"
                variant="primary-action"
              >
                <b-icon icon="pencil-square" aria-hidden="true"></b-icon>
              </BaseButtonComponent>
              <BaseButtonComponent
                @click="() => remove(item)"
                size="sm"
                v-b-tooltip.hover
                title="Excluir"
                variant="danger"
              >
                <b-icon icon="trash" aria-hidden="true"></b-icon>
              </BaseButtonComponent>
              <BaseButtonComponent
                :to="`/investment-investors/${item.id}`"
                size="sm"
                v-b-tooltip.hover
                title="Investidores"
                variant="secondary-action"
              >
                <b-icon icon="people" aria-hidden="true"></b-icon>
              </BaseButtonComponent>
            </td>
          </tr>
        </tbody>
      </v-table>

      <b-pagination-nav
        class="mt-3"
        :link-gen="linkGen"
        :number-of-pages="state.pageCount"
        use-router
      ></b-pagination-nav>
    </div>
    <empty-list v-else-if="!viewData.loading"></empty-list>
  </main>
</template>

<script>
import helpers from '../../vue/helpers';
import { Api } from '../../vue/api';
import { BaseButtonComponent } from '../../ui/buttons';

const API = new Api();

export default {
  name: 'investment-index',
  data: function() {
    return {
      state: {
        list: [],
        page: 1,
        pageCount: 1,
        count: 0,
      },
      viewData: {
        loading: true,
        search: '',
      },
      isTopDirection: {
        depositDate: false,
      },
      varType: {
        depositDate: 'string',
      },
      fields: {
        depositDate: false,
      },
      lastColumnFiltered: '',
    };
  },
  computed: {},
  beforeMount: async function() {
    if (this.$route.query && this.$route.query.search) {
      this.viewData.search = this.$route.query.search;
    }

    await this.getAll();
  },
  methods: {
    linkGen(pageNum) {
      return pageNum === 1 ? '?' : `?page=${pageNum}`;
    },
    search() {
      this.$router.push({
        query: { page: 1, search: this.viewData.search },
      });
    },
    async getAll() {
      try {
        this.viewData.loading = true;

        const { model: { list: result = [], pageCount } = {} } = await API.post(
          '/execute',
          {
            path: '/investments' + helpers.toQueryString(this.$route.query),
            method: 'get',
          },
        );

        this.state.list = [...result];
        this.state.pageCount = pageCount;
        this.viewData.loading = false;
      } catch (ex) {
        this.$toast.error(helpers.getFirstError(ex));
      }
    },
    async remove(item) {
      const ok = await this.$bvModal.msgBoxConfirm(
        `Deseja mesmo excluir [${item.name}] ?`,
        {
          title: 'Confirmar Exclusão',
          size: 'md',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'Sim',
          cancelTitle: 'Não',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true,
        },
      );

      if (!ok) {
        return;
      }

      try {
        this.viewData.loading = true;

        const result = await API.post('/execute', {
          path: '/investment/' + item.id,
          method: 'delete',
        });

        this.$toast.success('Investimento excluída com sucesso');
        await this.getAll();
      } catch (ex) {
        this.$toast.error(helpers.getFirstError(ex));
      }
    },
    defineArrowDirection(fieldName) {
      if (!this.lastColumnFiltered) {
        this.lastColumnFiltered = fieldName;
        console.log(this.isTopDirection);
        console.log(this.isTopDirection[fieldName]);
        this.isTopDirection[fieldName] = true;
        this.state.paginationOrder = 'ASC';
        return;
      }
      if (this.lastColumnFiltered === fieldName) {
        this.isTopDirection[fieldName] = !this.isTopDirection[fieldName];
        this.isTopDirection[fieldName]
          ? (this.state.paginationOrder = 'ASC')
          : (this.state.paginationOrder = 'DESC');
        return;
      }
      this.lastColumnFiltered = fieldName;
      this.isTopDirection[fieldName] = true;
      this.state.paginationOrder = 'ASC';
      return;
    },
    showArrowInSpecificField(fieldName) {
      for (const field of Object.keys(this.fields)) {
        if (field === fieldName) {
          this.fields[field] = true;
          continue;
        }
        this.fields[field] = false;
      }
      this.defineArrowDirection(fieldName);
    },
    sortList(sColumn) {
      this.showArrowInSpecificField(sColumn);

      this.state.list.sort((a, b) => {
        if (this.isTopDirection[sColumn]) {
          if (
            a[sColumn] === '' ||
            a[sColumn] === null ||
            a[sColumn] === undefined ||
            a[sColumn] === 0
          )
            return 1;
          if (
            b[sColumn] === '' ||
            b[sColumn] === null ||
            b[sColumn] === undefined ||
            b[sColumn] === 0
          )
            return -1;
          return this.varType[sColumn] === 'number'
            ? a[sColumn] - b[sColumn]
            : a[sColumn].localeCompare(b[sColumn]);
        } else {
          if (
            a[sColumn] === '' ||
            a[sColumn] === null ||
            a[sColumn] === undefined ||
            a[sColumn] === 0
          )
            return 1;
          if (
            b[sColumn] === '' ||
            b[sColumn] === null ||
            b[sColumn] === undefined ||
            b[sColumn] === 0
          )
            return -1;
          return this.varType[sColumn] === 'number'
            ? b[sColumn] - a[sColumn]
            : b[sColumn].localeCompare(a[sColumn]);
        }
      });
    },
  },
  components: {
    BaseButtonComponent,
  },
};
</script>
